module.exports = __webpack_public_path__ + "static/media/Susi Holman.1d7fc38f.png";